import requestService from './requestService';
import { getLang } from '../i18n';

const endpoints = {
  languageList: '/user/languageList',
  hotlineLanguageList: '/integrations/hotline/langs'
};

export const getLanguageList = async (options = {}) => {
  const { prebooked = false, orderTime = null, presence = null } = options;
  let params = 'fullJson=true&multipleSkills=true&closeChatRooms=true&includePrebooking=true&call_state=NoCall';
  
  params += `&prebooked=${prebooked}`;
  if (orderTime) {
    params += `&orderTime=${encodeURIComponent(orderTime)}`;
  }
  if (prebooked && presence) {
    params += `&presence=${encodeURIComponent(presence)}`;
  }

  try {
    return requestService.get(`${endpoints.languageList}`, params, {apiType: 'platform-v2'});
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getLanduageWithCodeList = async (locale='eng') => {
  const params = `locale=${locale}`;
  try {
    return requestService.get(`${endpoints.hotlineLanguageList}`, params, {apiType: 'integration', withoutDefaultParams: true});
  } catch (e) {
    console.error(e);
    throw e;
  }
};

// The language names in the list are localized for the UI language at request time (requestService
// adds `locale`). When the UI language changes while the request is pending, the response that
// lands is in the previous language: it is discarded and the list requested again, so the caller
// can cache the names under the locale they were really fetched in (TUL-6124). `deps` exists for
// tests.
export const getLanguageListInCurrentLocale = async (options = {}, deps = {}) => {
  const { fetchList = getLanguageList, currentLocale = getLang } = deps;
  for (;;) {
    const locale = currentLocale();
    const json = await fetchList(options);
    if (currentLocale() === locale) {
      return { json, locale };
    }
  }
};
